import { UsuarioPerfil, VinculoUsuarioOperadora } from '../api/ords/model';

/**
 * De quais operadoras o usuário recebe workspace. É eixo diferente de funcionalidade, que diz o
 * que ele pode fazer dentro do workspace, e sai da composição de três colunas do papel
 * (`apl_papel_acesso`), que o perfil devolve:
 *
 * | Papel                                    | id_nivel_acesso | ib_operadora | ib_administrador | Abrangência |
 * |------------------------------------------|-----------------|--------------|------------------|-------------|
 * | SUPER_ADMINISTRADOR                      | 0               | 0            | 1                | `CLIENTES`  |
 * | ADMINISTRADOR                            | 1               | 0            | 1                | `CLIENTES`  |
 * | OPERADOR_MEMBRO / COORDENADOR / VENDEDOR | 1               | 1            | 0                | `VINCULO`   |
 * | OPERADOR_CONVIDADO                       | 2               | 1            | 0                | `NENHUMA`   |
 * | BASICO                                   | 2               | 0            | 0                | `NENHUMA`   |
 *
 * O nível `2` é testado antes da flag de vínculo: o Convidado tem vínculo (`ib_operadora = 1`),
 * para receber e-mail e notificações da operadora, mas não entra no workspace dela. Ler a flag
 * sozinha lhe daria o workspace. Cada linha tem um `it` em `abrangencia.spec.ts`.
 */
export type AbrangenciaOperadoras = 'CLIENTES' | 'VINCULO' | 'NENHUMA';

type PapelDoPerfil = Pick<UsuarioPerfil, 'id_nivel_acesso' | 'ib_operadora' | 'ib_administrador'>;

export function resolverAbrangencia(perfil: PapelDoPerfil | null | undefined): AbrangenciaOperadoras {
  if (!perfil || perfil.id_nivel_acesso === 2) {
    return 'NENHUMA';
  }
  if (perfil.ib_administrador === 1) {
    return 'CLIENTES';
  }
  if (perfil.ib_operadora === 1) {
    return 'VINCULO';
  }
  return 'NENHUMA';
}

/** Vínculos que viram workspace; os do Convidado existem, mas ficam de fora. */
export function vinculosDoWorkspace(perfil: UsuarioPerfil | null | undefined): VinculoUsuarioOperadora[] {
  return resolverAbrangencia(perfil) === 'VINCULO' ? (perfil.operadoras_vinculadas ?? []) : [];
}
